import { useTranslation } from 'react-i18next';
import { ELanguage } from '../../types/lang';
import { locales } from './locales';

export const useLocalizedFns = () => {
  const { i18n } = useTranslation();

  return locales[i18n.language as ELanguage];
};
